import { connect } from "react-redux";
import { default as component } from "./UserDetailsTable.jsx";

// UI actions
import { activateModal } from "../../common/UI/ActiveModal/duck/actions";

// Local Selectors
import { getUserDetails } from "../duck/selectors"

const mapStateToProps = state => {
  return {
    user: getUserDetails(state)
  };
};

const mapDispatchToProps = {
  activateModal
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
